import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {TemplateEditComponent} from './template-edit.component';

const routes: Routes = [
  { path: 'template/:id',   component: TemplateEditComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TemplateEditRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/template/template-edit/template-edit-routing.module.ts